import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import dayjs from "dayjs";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import AlertModal from "../../../../Modal/AlertModal";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import Flex from "../../../../DefaultStyles/Flex";
import { Overlay } from "../../../../Modal/DefaultModalLayout";
import { IPartyExitPartyData } from "./PartyExitModal";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

interface PartyExitAlertModalProps {
  cancelEvent: () => void;
  closeEvent: () => void;
  partyData: IPartyExitPartyData;
  reason: string;
  check: {
    first: boolean;
    second: boolean;
    third: boolean;
    fourth: boolean;
    fifth?: boolean;
  };
}

interface BreakYoutubeResultData {
  break_result?: boolean;
  cancel_result?: boolean;
  cancel_error?: string;
  cancel_money?: number | string;
}

export default function PartyExitAlertModal({
  cancelEvent,
  closeEvent,
  partyData,
  reason,
  check,
}: PartyExitAlertModalProps) {
  console.log(partyData);

  const grade = partyData?.grade;

  const [noFault, setNoFault] = useState(false); // 무책 / 무책일할
  const [hasFault, setHasFault] = useState(false); // 유책
  const [reward, setReward] = useState(false); // 보상 (탈퇴)
  const [breakPay, setBreakPay] = useState(false); // 먹튀 (해산)
  const [breakYoutube, setBreakYoutube] = useState(false); // 유튜브 해산
  const [showDatePicker, setShowDatePicker] = useState(false); // 유튜브 해산 날짜 선택
  const [selectedDate, setSelectedDate] = useState(""); // 선택된 날짜
  const [showBreakYoutubeResult, setShowBreakYoutubeResult] = useState(false);
  const [breakYoutubeResult, setBreakYoutubeResult] =
    useState<BreakYoutubeResultData | null>(null);

  const isUplus = partyData?.subsId === 900001;
  const today = dayjs().format("YYYY-MM-DD");
  const minDate = partyData?.startdate
    ? dayjs(partyData.startdate).format("YYYY-MM-DD")
    : "";

  console.log(noFault);
  // 무책 / 무책일할
  const {
    response: noFaultResponse,
    error: noFaultError,
    loading: noFaultLoading,
  } = useApi({
    method: "post",
    url: noFault
      ? isUplus
        ? `uplus2/escape`
        : grade === 0
          ? `party/break`
          : `party/exit`
      : undefined,
    data: {
      uid: String(partyData?.uid),
      partyid: String(partyData?.partyId),
      reason,
      ...(!isUplus && { type: check?.first ? true : false }),
    },
  });

  // 유책
  const {
    response: hasFaultResponse,
    error: hasFaultError,
    loading: hasFaultLoading,
  } = useApi({
    method: "post",
    url: hasFault ? "party/penalty" : undefined,
    data: {
      uid: String(partyData?.uid),
      partyid: String(partyData?.partyId),
      reason,
      membs: partyData?.membs ?? 0,
      type: grade === 0 ? "breaking" : "exiting",
    },
  });

  // 파티 탈퇴 - 보상
  const {
    response: rewardResponse,
    error: rewardError,
    loading: rewardLoading,
  } = useApi({
    method: "post",
    url: reward ? `party/reward` : undefined,
    data: {
      uid: String(partyData?.uid),
      partyid: String(partyData?.partyId),
      reason,
    },
  });

  // 파티 해산 - 먹튀
  const {
    response: breakPayResponse,
    error: breakPayError,
    loading: breakPayLoading,
  } = useApi({
    method: "post",
    url: breakPay ? `party/breakPay` : undefined,
    data: {
      uid: String(partyData?.uid),
      partyid: String(partyData?.partyId),
      reason,
      membs: partyData?.membs ?? 0,
    },
  });

  // 파티 해산 - 유튜브
  const {
    response: breakYoutubeResponse,
    error: breakYoutubeError,
    loading: breakYoutubeLoading,
  } = useApi({
    method: "post",
    url: breakYoutube ? `party/break_youtube` : undefined,
    data: {
      uid: String(partyData?.uid),
      partyid: String(partyData?.partyId),
      reason,
      membs: partyData?.membs ?? 0,
      date: selectedDate,
    },
  });

  const checkString = () => {
    if (check.first) {
      return "무책";
    } else if (check.second) {
      return "무책 일할";
    } else if (check?.third) {
      return "유책";
    } else if (check?.fourth) {
      if (grade === 0) {
        return "먹튀";
      } else {
        return "보상";
      }
    } else if (check?.fifth) {
      return "Apply Proxy";
    }
  };

  const getBreakYoutubeResult = (
    responseData: any,
  ): BreakYoutubeResultData | null => {
    if (!responseData || typeof responseData !== "object") {
      return null;
    }

    if ("break_result" in responseData || "cancel_result" in responseData) {
      return responseData as BreakYoutubeResultData;
    }

    if (responseData?.data && typeof responseData.data === "object") {
      return responseData.data as BreakYoutubeResultData;
    }

    return null;
  };

  const formatCancelMoney = (value?: number | string) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }

    const parsed =
      typeof value === "number" ? value : Number(String(value).replace(/,/g, ""));

    if (Number.isNaN(parsed)) {
      return String(value);
    }

    return `${parsed.toLocaleString()}원`;
  };

  useEffect(() => {
    if (breakYoutubeResponse?.status === 201) {
      setBreakYoutubeResult(getBreakYoutubeResult(breakYoutubeResponse?.data));
      setShowBreakYoutubeResult(true);
      return;
    }

    if (
      noFaultResponse?.status === 200 ||
      hasFaultResponse?.status === 200 ||
      rewardResponse?.status === 200 ||
      breakPayResponse?.status === 200
    ) {
      cancelEvent();
      closeEvent();

      toast.success(
        `파티 ${grade === 0 ? "해산이" : "탈퇴가"} 완료되었습니다.`,
      );
    }
  }, [
    noFaultResponse,
    hasFaultResponse,
    rewardResponse,
    breakPayResponse,
    breakYoutubeResponse,
    cancelEvent,
    closeEvent,
    grade,
  ]);

  useEffect(() => {
    if (noFaultError) {
      toast.error(noFaultError.data);
    }
  }, [noFaultError]);

  useEffect(() => {
    if (hasFaultError) {
      toast.error(hasFaultError.data);
    }
  }, [hasFaultError]);

  useEffect(() => {
    if (rewardError) {
      toast.error(rewardError.data);
    }
  }, [rewardError]);

  useEffect(() => {
    if (breakPayError) {
      toast.error(breakPayError.data);
    }
  }, [breakPayError]);

  useEffect(() => {
    if (breakYoutubeError) {
      toast.error(breakYoutubeError.data);
    }
  }, [breakYoutubeError]);

  return (
    <>
      <AlertModal
        cancelEvent={() => cancelEvent()}
        confirmText={grade === 0 ? "해산" : "탈퇴"}
        title={
          <span>
            {partyData?.uid}_{partyData?.name}_{partyData?.nickname}님의 <br />
            {partyData?.subsId}_{getSubsNameBySubsId3(partyData?.subsId)} 파티가{" "}
            <strong>{checkString()}</strong> {grade === 0 ? "해산" : "탈퇴"}
            됩니다. 계속 하시겠습니까?
          </span>
        }
        confirmEvent={() => {
          if (check?.first || check?.second) {
            // 무책 / 무책 일할
            setNoFault(true);
          } else if (check?.third) {
            // 유책
            setHasFault(true);
          } else if (check?.fourth) {
            if (grade === 0) {
              // 먹튀
              setBreakPay(true);
            } else {
              // 보상
              setReward(true);
            }
          } else if (check?.fifth) {
            // 유튜브 해산 - 날짜 선택 모달 표시
            setShowDatePicker(true);
          }
        }}
      />

      {/* 유튜브 해산 날짜 선택 모달 */}
      {showDatePicker && (
        <Overlay id="datepicker-overlay" style={{ zIndex: 31 }}>
          <DatePickerContainer>
            <DatePickerTitle>해산 날짜 선택</DatePickerTitle>
            <DatePickerDesc>
              파티 시작일({minDate})부터 오늘({today})까지 선택 가능합니다.
            </DatePickerDesc>
            <DateInput
              type="date"
              value={selectedDate}
              min={minDate}
              max={today}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
            <Flex gapSize={8} style={{ marginTop: 20 }}>
              <ConfirmBtn
                btnText="취소"
                btnColor="white"
                btnClickEvent={() => {
                  setShowDatePicker(false);
                  setSelectedDate("");
                }}
              />
              <ConfirmBtn
                btnText="해산"
                btnColor="red"
                isDisabled={!selectedDate}
                btnClickEvent={() => {
                  setShowDatePicker(false);
                  setBreakYoutube(true);
                }}
              />
            </Flex>
          </DatePickerContainer>
        </Overlay>
      )}

      {(noFaultLoading ||
        hasFaultLoading ||
        rewardLoading ||
        breakPayLoading ||
        breakYoutubeLoading) && <Loader />}

      {showBreakYoutubeResult && (
        <Overlay id="break-youtube-result-overlay" style={{ zIndex: 32 }}>
          <ResultContainer>
            <ResultTitle>유튜브 해산 처리 결과</ResultTitle>
            <ResultRow>
              <ResultLabel>해산 성공</ResultLabel>
              <ResultValue>
                {breakYoutubeResult?.break_result ? "성공" : "실패"}
              </ResultValue>
            </ResultRow>
            <ResultRow>
              <ResultLabel>카드사 취소</ResultLabel>
              <ResultValue>
                {breakYoutubeResult?.cancel_result ? "성공" : "실패"}
              </ResultValue>
            </ResultRow>
            <ResultRow>
              <ResultLabel>카드취소 에러</ResultLabel>
              <ResultValue>{breakYoutubeResult?.cancel_error || "-"}</ResultValue>
            </ResultRow>
            <ResultRow>
              <ResultLabel>취소 금액</ResultLabel>
              <ResultValue>
                {formatCancelMoney(breakYoutubeResult?.cancel_money)}
              </ResultValue>
            </ResultRow>

            <Flex gapSize={8} style={{ marginTop: 20 }}>
              <ConfirmBtn
                btnText="확인"
                btnColor="red"
                btnClickEvent={() => {
                  setShowBreakYoutubeResult(false);
                  cancelEvent();
                  closeEvent();
                  toast.success("파티 해산이 완료되었습니다.");
                }}
              />
            </Flex>
          </ResultContainer>
        </Overlay>
      )}
    </>
  );
}

const DatePickerContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 28px 24px;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DatePickerTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #1a1a1a;
`;

const DatePickerDesc = styled.p`
  font-size: 13px;
  color: #888;
  margin-bottom: 16px;
  text-align: center;
  line-height: 1.5;
`;

const DateInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: #4a90d9;
  }
`;

const ResultContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 28px 24px;
  min-width: 420px;
  display: flex;
  flex-direction: column;
`;

const ResultTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #1a1a1a;
`;

const ResultRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
`;

const ResultLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

const ResultValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: right;
  word-break: break-all;
`;
